import { useState, useEffect } from 'react';
import styles from './NotFound.module.scss';

const NotFound = () => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles.not_found_container}>
      {showContent && (
        <div className={styles.not_found_content}>
          <h2 className={styles.not_found_title}>404 Not Found</h2>
          <p className={styles.not_found_message}>
            Sorry, the page you are looking for does not exist.
          </p>
          {/* Optional: Include an image */}
          {/* <img className={styles.not_found-image}" src="/path/to/your/image.jpg" alt="404 Not Found" /> */}
        </div>
      )}
    </div>
  );
};

export default NotFound;
